import script from "./InspectionViewerCreateAnnotationFormGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./InspectionViewerCreateAnnotationFormGroup.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__